export default __webpack_public_path__ + "static/topic13-d02288ad7287864fad4b767b83adbb3e.png";